import React from "react"
import BaseChart from './BaseChart'

const Bar = (props)=>(
    <BaseChart type='bar' {...props}  />
)

export default Bar